import OrderableModel from '@/models/OrderableModel';
import store from '@/store';

export default class TicketStatus extends OrderableModel {
    get route () {
        return 'ticket-statuses';
    }

    static get className () {
        return 'TicketStatus';
    }

    static get isInStore () {
        return true;
    }

    static getIdByType (type) {
        const types = {
            open: 1,
            closed: 2,
            archived: 3,
            waiting_for_reply: 4,
            got_reply: 5,
            scheduled: 6,
        };

        const status = store.getters.getFilteredValue('ticketStatuses', (status) => {
            return status.internal_type === types[type];
        });

        return status ? status.id : null;
    }
}
